/**
 * 将接口返回的 category 原始值规范化为映射表 key（小写 + 空格转下划线）
 * @param {string} raw
 */
export function normalizeCategoryLookupKey(raw) {
  return String(raw ?? '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_');
}

/**
 * 根据当前语言解析分类展示文案；无翻译时返回原始英文
 * @param {string} raw 接口 category 原始值
 * @param {(key: string) => string} t vue-i18n t
 * @param {(key: string) => boolean} te vue-i18n te
 */
export function resolveCategoryLabel(raw, t, te) {
  const original = String(raw ?? '').trim();
  if (!original) return '';

  if (original.toLowerCase() === 'all') {
    const allKey = 'markets.categories.all';
    return te(allKey) ? t(allKey) : original;
  }

  const lookupKey = normalizeCategoryLookupKey(original);
  const i18nKey = `markets.categoryLabels.${lookupKey}`;
  if (te(i18nKey)) return t(i18nKey);

  return original;
}
